import React from "react";
import swal from 'sweetalert';
import history from "../auth/history";

class TokenErrorHandler extends React.Component {


    tokenErrorHandle(message, callBackUrl) {
      setTimeout(() => {
        swal({
            title: "Sorry!",
            text: 'Authentication Error! Please Click to re-login',
            icon: "error",
            button: true,
            dangerMode: true,
        }).then(() => {
            history.push('/cms-login');
            history.go();

        });
      }, 1000);
    }
}


export default new TokenErrorHandler();
